import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function StatDetails(props) {
  const attRange = props.character.getAttackRange();
  const attackRangeString = "".concat(
    attRange.min,
    "-",
    attRange.max,
  );
  return (
    <Row>
      <Col xs={3}>
        <div> Att: </div>
        <div> Def: </div>
        <div> Stat: </div>
        <div> Stat: </div>
        <div> Stat: </div>
        <div> Stat: </div>
      </Col>
      <Col xs={9}>
        <div> {attackRangeString} </div>
        <div> {props.character.getTotalDefense()} </div>
        <div> {0} </div>
        <div> {0} </div>
        <div> {0} </div>
        <div> {0} </div>
      </Col>
    </Row>
  );
}

export default StatDetails;
